import {connect} from "react-redux";

import UploadFile from "../../../../components/Chat/ChatCase/Modal/UploadFile";
import {setErrorUploadMess, setSuccessUploadMess} from "../../../../actions/modal";
import {setRedirection} from "../../../../actions/user";
import {postDocumentAsMessage} from "../../../../actions/chatCase/form";
import {getMessages} from "../../../../actions/chatCase/messages";
import {getDocuments} from "../../../../actions/chatCase/document";

const MapStateToProps = (state) => ({
successUploadMess: state.modal.successUploadMess,
errorUploadMess: state.modal.errorUploadMess
});

const MapDispatchToProps = (dispatch) => ({
setSuccessUploadMess: (msg) => {
dispatch(setSuccessUploadMess(msg));
},
setErrorUploadMess: (msg) => {
dispatch(setErrorUploadMess(msg));
},
setRedirection: (bool) => {
dispatch(setRedirection(bool));
},
postDocumentAsMessage: (id) => {
dispatch(postDocumentAsMessage(id));
},
getMessages: () => {
dispatch(getMessages());
},
getDocuments: () => {
dispatch(getDocuments());
},
});

export default connect(MapStateToProps, MapDispatchToProps)(UploadFile);